import React, { Fragment } from "react"
import './login.scss'

import { Link } from 'react-router-dom'

import Navbar from '../../components/newNavbar/navbar'
import Button from '../../components/newButton/button'
import Input from '../../components/newInput/input'
import ImgPage from '../../components/imgPage/imgPage'
// import { toast } from "react-toastify";
import { SigninUser } from "../../queries/player";
import Loading from "../../components/loading/loading";
import Simplert from 'react-simplert'
import { Mutation } from "react-apollo";
import ErrorM from '../../components/ErrorMessange/errormenssage'
// import Modal from '../../components/Modal/modal'
import { GraphQLClient } from 'graphql-request'
import { endpoint } from "../../queries/endpoint"
import generatePassword from 'password-generator'
import * as emailjs from 'emailjs-com'
import Modal from '../../components/Modal/modal'
import ErrorBroundray from '../../components/errorBoundary/errorBoundary'
import PasswordMeter from '../../components/PassworMeter/passwordmeter'

export default class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showAlert: false,
            typeAlert: '',
            titleAlert: '',
            messageAlert: '',
            customCloseBtnText: 'Fechar',
            customCloseBtnClass: 'buttonnot', // colocar cor roxa
            onClose: null,
            emailok: false,
            spinneremail: false,
            emailErr: null,
            show: false,
            show2: false,
            passErr: null,
            emailPok: false,
            loadingP: false,
        }


        this._loginInfo = {}
        this.pass = {}
        this.remake = {}

        this.setInput = event => {
            this.setState({ value: event.target.value, showAlert: false });
            this._loginInfo[`${event.target.name}`] = event.target.value
            return this.state.value
        } //_setInput

        this.setInputPass = event => {
            this.setState({ value: event.target.value, showAlert: false });
            this.pass[`${event.target.name}`] = event.target.value
            return this.state.value
        } //_setInput

        this.documentMask = e => {
            let documentMasked = e.target.value;
            //Adiciona um ponto entre o terceiro e o quarto dígito
            documentMasked = documentMasked.replace(/^(\d{3})(\d)/, "$1.$2");
            //Adiciona um ponto entre o sexto e o setimo dígito
            documentMasked = documentMasked.replace(
                /^(\d{3})\.(\d{3})(\d)/,
                "$1.$2.$3"
            );
            //Adiciona um traço entre o nono e o decimo dígito
            documentMasked = documentMasked.replace(/(\.\d{3})(\d{2})$/, "$1-$2");
            // return (this._infoModal.document.value = documentMasked.slice(0, 14));
            this.pass['docForgot'] = documentMasked.slice(0, 14)
            return (e.target.value = documentMasked.slice(0, 14));
        }; //_documentMask

        this.blurEmail = () => {
            this.setState({ showAlert: false, spinneremail: true })
            if (this._loginInfo.email) {
                if (this._loginInfo.email.includes('@') && this._loginInfo.email.split("@")[1].includes('.')) {
                    this.setState({ emailok: true, spinneremail: false, emailErr: null })
                } else {
                    this.setState({
                        emailErr: <ErrorM color="danger" content='E-mail inválido. Por favor, digite novamente. Ex.: jose@email.com' />,
                        emailok: false,
                        spinneremail: false,
                    })
                }
            } else {
                this.setState({ emailok: false, spinneremail: false, emailErr: null })
            }
        }

        this.blurEmailPass = () => {
            this.setState({ showAlert: false, passErr: null })
            if (this.pass.emailForgot && this.pass.emailForgot.length > 5) {
                if (this.pass.emailForgot !== undefined && this.pass.emailForgot.includes('@') && this.pass.emailForgot.split("@")[1].includes('.')) {
                    this.setState({ emailPok: true, emailErr: null })
                } else {
                    this.setState({
                        passErr: <ErrorM color="danger" content='E-mail inválido. Por favor, digite novamente. Ex.: jose@email.com' />,
                        emailPok: false,
                    })
                }
            } else {
                this.setState({ emailPok: false, spinneremail: false, emailErr: null })
            }

            if (this.remake.email && this.remake.email.length > 5) {
                if (this.remake.email !== undefined && this.remake.email.includes('@') && this.remake.email.split("@")[1].includes('.')) {
                    this.setState({ emailPok: true, emailErr: null })
                } else {
                    this.setState({
                        passErr: <ErrorM color="danger" content='E-mail inválido. Por favor, digite novamente. Ex.: jose@email.com' />,
                        emailPok: false,
                    })
                }
            } else {
                this.setState({ emailPok: false, spinneremail: false, emailErr: null })
            }
        }

        this._loginSubmit = (SigninUser, e) => {
            e.preventDefault()
            // console.log(e)
            // console.log("entrou")
            this.setState({ showAlert: false, loading: true })
            if (this._loginInfo.email && this._loginInfo.password && this.state.emailok) {
                // console.log(this._loginInfo)
                SigninUser({
                    variables: {
                        email: this._loginInfo.email.toString(),
                        password: this._loginInfo.password.toString(),
                    }
                }).then(
                    res => {
                        console.log(res)
                        const userAuth = {
                            token: res.data.authUser.token,
                            user: res.data.authUser.user
                        }

                        sessionStorage.setItem('OITO', JSON.stringify(userAuth))
                        window.location.href = '/perfil'
                    }
                ).catch(err => {
                    console.log(err)
                    // if (err) {
                    this.setState({
                        loading: false,
                        showAlert: true,
                        typeAlert: 'error',
                        titleAlert: 'E-mail e/ou senha inválidos!',
                        messageAlert: '',
                        esqueci: true,
                        onClose: this.showModal2
                    })
                    // }
                    this._loginInfo = {}
                    this.setState({ emailok: false, spinneremail: false, emailErr: null })
                    document.getElementById('formlogin').reset()
                })
            }
        } //_loginSubmit

        this.newPassword = () => {
            this.setState({ loadingP: true, show: false })
            const client = new GraphQLClient(endpoint)

            const newPass = generatePassword(12, false)
            // console.log(newPass)

            if (this.state.emailPok) {

                client.request(`
                mutation {
                    allUsers(filter: {
                        email: "${this.pass.emailForgot.toString()}"
                    }) {
                        name
                        email
                    }
                }`).then(
                    res => {
                        if (res.allUsers) {
                            if (res.allUsers[0]) {

                                const usuario = res.allUsers[0]
                                //enviar email
                                var template_params = {
                                    "email": usuario.email,
                                    "title": "Sua senha foi redefinida.",
                                    "name": usuario.name,
                                    "message": `Oi ${usuario.name}. Foi solicitada a recuperação de senha. Sua nova senha é: ${newPass}. Entre em seu perfil e troque por uma senha segura.`
                                }

                                emailjs.send('noreply', 'default', template_params, "user_IagwdTtEr3AVRdLhxkyKc")
                                    .then((response) => {
                                        console.log('SUCCESS!', response.status, response.text)

                                        this.form = {}

                                        client.request(`
                                            mutation {
                                                recoverUserPassword (
                                                    email: "${usuario.email}"
                                                    password: "${newPass}"
                                                )}`).then(
                                            res => {
                                                if (res) {

                                                    sessionStorage.clear()

                                                    //enviar modal de confirmacao
                                                    this.setState({
                                                        showAlert: true,
                                                        typeAlert: 'success',
                                                        titleAlert: 'Nova senha solicitada com sucesso!',
                                                        messageAlert: 'Verifique seu e-mail para ver sua nova senha.',
                                                        onClose: () => window.location.reload(),
                                                        loadingP: false,
                                                        show2: false,
                                                        show: false,
                                                    })
                                                    console.log("tudo ok")
                                                } else {
                                                    console.log("não cadastrado")
                                                    this.setState({
                                                        passErr: <ErrorM color="danger" content='E-mail esta incorreto. Por favor, digite novamente ou ' linkHref="/cadastro" link='cadastre-se.' />,
                                                        emailPok: false,
                                                        loadingP: false,
                                                    })
                                                    this.pass = {}
                                                    document.getElementById('newPassForm').reset()
                                                }
                                            }
                                        ).catch(err => console.log(err))
                                    }, function (error) {
                                        console.log('FAILED...', error)
                                    });
                            }
                        }
                    })
            }
        }

        this.remakePassword = () => {
            this.setState({ loadingP: true, show: false })
            const client = new GraphQLClient(endpoint)

            // console.log(newPass)

            if (this.state.emailPok && this.remake.email && this.remake.password) {
                console.log("validado inputs")

                client.request(`
                mutation {
                    recoverUserPassword (
                        email: "${this.remake.email}"
                        password: "${this.remake.password}"
                    )}`).then(
                    res => {
                        console.log(res)
                        if (res) {

                            //enviar modal de confirmacao
                            this.setState({
                                loadingP: false,
                                show2: false,
                                show: false,
                                showAlert: true,
                                typeAlert: 'success',
                                titleAlert: 'Nova senha solicitada com sucesso!',
                                messageAlert: 'Verifique seu e-mail para ver sua nova senha.',
                                onClose: () => window.location.reload(),
                            })
                            console.log("tudo ok")
                        } else {
                            console.log("não cadastrado")
                            this.setState({
                                passErr: <ErrorM color="danger" content='E-mail esta incorreto. Por favor, digite novamente ou ' linkHref="/cadastro" link='cadastre-se.' />,
                                emailPok: false,
                                loadingP: false,
                            })
                            this.pass = {}
                            document.getElementById('newPassForm').reset()
                        }
                    }
                )
            }

        }

        this.showModal = e => {
            this.setState({
                show: !this.state.show
            });
        };

        this.showModal2 = e => {
            this.setState({
                show2: !this.state.show2
            });
        };
    }

    render() {

        const cache = JSON.parse(sessionStorage.getItem('OITO'))
        if (cache)
            window.location.href = "/perfil"


        const LastURL = JSON.parse(sessionStorage.getItem('LastURL'))
        // console.log(sessionStorage.getItem('LastURL'))
        if (LastURL) {

            if (LastURL.path !== window.location.pathname) {
                const listHistory = {
                    count: parseInt(LastURL.count) - 1,
                    path: window.location.pathname
                }
                sessionStorage.setItem('LastURL', JSON.stringify(listHistory))
            }
        }

        return (
            <Fragment>
                <ErrorBroundray><Navbar /></ErrorBroundray>
                <Simplert
                    showSimplert={this.state.showAlert}
                    type={this.state.typeAlert}
                    title={this.state.titleAlert}
                    message={this.state.messageAlert}
                    customCloseBtnText={this.state.customCloseBtnText}
                    customCloseBtnClass={this.state.customCloseBtnClass}
                    onClose={this.state.onClose}
                />

                {this.state.loadingP ? <Loading /> : null}
                {this.state.loading ? <Loading /> : null}

                <ErrorBroundray><ImgPage>
                    <div className={'col-xs-12'}>
                        <div className="login-div row middle-xs">
                            <div className="col-xs-12">
                                <h1>Seja bem-vindo a OITO!</h1>
                                <span>Anuncie seus serviços, encontre profissionais, conecte-se e faça uma grana extra.</span>
                            </div>

                            <div className="col-xs-12">
                                <form id='formlogin'>
                                    <Input name={'email'} type={'email'} placeholder={'E-mail'} onChange={this.setInput} onBlur={this.blurEmail} required={true} />
                                    {this.state.emailErr}
                                    <Input name={'password'} isPassword={true} type={'password'} placeholder={'Senha'} onChange={this.setInput} minlength={8} required={true} />
                                    <div>
                                        <Mutation mutation={SigninUser}>
                                            {(SigninUser, { loading }) => {
                                                if (loading) return <Loading />
                                                return <Button type="submit" onClick={(e) => this._loginSubmit(SigninUser, e)} name="Entrar" disabled={(this._loginInfo.email && this._loginInfo.password && this.state.emailok) ? false : true} />
                                            }}
                                        </Mutation>
                                    </div>
                                </form>
                            </div>

                            <div className="col-xs-12">
                                <span style={{ cursor: "pointer" }} onClick={() => this.showModal()}>Esqueci minha senha</span>
                            </div>

                            <div className="col-xs-12">
                                <span>Ainda não tem conta? <Link to={'/cadastro'}>Cadastre-se</Link></span>
                            </div>
                        </div>
                    </div>

                </ImgPage></ErrorBroundray>

                <Modal show={this.state.show} onClose={this.showModal} title='Esqueceu sua senha?'>
                    <p>Não se preocupe.</p>
                    <p>Em seguida você irá receber em seu e-mail a nova senha para acessar a Oito.</p>
                    {this.state.passErr}
                    <form id="newPassForm">
                        <Input name={'emailForgot'} type={'email'} placeholder={'E-mail. Ex.: joao@email.com'} onChange={this.setInputPass} onInput={this.blurEmailPass} required={true} />
                        {/* <Input name={'docForgot'} type={'text'} placeholder={'CPF. Ex.: 123.456.789-00'} onChange={this.setInputPass} onBlur={this.blurDoc} onKeyUp={this.documentMask} maxlength={14} required={true} /> */}
                        {!this.state.loadingP ?
                            // <Button type="submit" onClick={this.newPassword} name="Entrar" disabled={(this.state.emailPok && this.pass.docForgot) ? false : true} />
                            <Button type="submit" onClick={this.newPassword} name="Entrar" disabled={!this.state.emailPok} />
                            : <Loading />}
                    </form>
                </Modal>

                <Modal show={this.state.show2} onClose={this.showModal2} title='Troca de senha'>
                    <p>Para sua segurança, solicitamos atualização de senha periodicamente.</p>
                    <p>É simples. Preencha os campos abaixo com sua nova senha, confirme e pronto!</p>
                    {this.state.passErr}
                    <form id="newPassForm">
                        <Input name={'emailForgot'} type={'email'} placeholder={'E-mail. Ex.: joao@email.com'} onChange={(e) => this.remake.email = e.target.value} onInput={this.blurEmailPass} required={true} />
                        {/* <Input name={'docForgot'} type={'text'} placeholder={'CPF. Ex.: 123.456.789-00'} onChange={this.setInputPass} onBlur={this.blurDoc} onKeyUp={this.documentMask} maxlength={14} required={true} /> */}
                        <Input name={'password'} isPassword={true} placeholder={'Senha'} type={'password'} onChange={(e) => this.remake.password = e.target.value} required={true} minlength={8} onKeyUp={this.blurPassword} />
                        <PasswordMeter password={this.remake.password} />
                        {this.state.passwordErr}
                        {!this.state.loadingP ?
                            // <Button type="submit" onClick={this.newPassword} name="Entrar" disabled={(this.state.emailPok && this.pass.docForgot) ? false : true} />
                            <Button type="submit" onClick={this.remakePassword} name="Salvar" disabled={!this.state.emailPok && this.state.passwordErr} />
                            : <Loading />}
                    </form>
                </Modal>

            </Fragment>
        )
    }
}
